
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bushfire-support",
      function () {
        return require("private-next-pages/bushfire-support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bushfire-support"])
      });
    }
  